import type { MonthlyArpa } from "@warrenio/api-spec/spec.oats.gen";

export const adminMonthlyArpaExample: MonthlyArpa[] = [
    {
        period_start_month: 1733011200,
        paying_ba_count: 498,
        arpa: 208.26,
    },
    {
        period_start_month: 1735689600,
        paying_ba_count: 488,
        arpa: 217.38,
    },
    {
        period_start_month: 1738368000,
        paying_ba_count: 488,
        arpa: 197.8,
    },
    {
        period_start_month: 1740787200,
        paying_ba_count: 484,
        arpa: 220.12,
    },
    {
        period_start_month: 1743465600,
        paying_ba_count: 480,
        arpa: 206.9,
    },
    {
        period_start_month: 1746057600,
        paying_ba_count: 476,
        arpa: 215.16,
    },
    {
        period_start_month: 1748736000,
        paying_ba_count: 476,
        arpa: 217.38,
    },
    {
        period_start_month: 1751328000,
        paying_ba_count: 480,
        arpa: 221.02,
    },
    {
        period_start_month: 1754006400,
        paying_ba_count: 476,
        arpa: 230.28,
    },
    {
        period_start_month: 1756684800,
        paying_ba_count: 478,
        arpa: 220.64,
    },
    {
        period_start_month: 1759276800,
        paying_ba_count: 478,
        arpa: 230.64,
    },
    {
        period_start_month: 1761955200,
        paying_ba_count: 490,
        arpa: 223.06,
    },
];
